import React from 'react';
import { QuoteIcon } from './QuoteIcon';

export const TestimonialCard = ({ text, author, location }) => {
  return (
    <div className="card h-100 shadow-sm" style={{ minHeight: '218px' }}>
      <div className="card-body d-flex flex-column">
        <div className="mb-3">
          <QuoteIcon />
        </div>

        <div className="flex-grow-1 d-flex flex-column justify-content-between">
          <blockquote className="mb-4" style={{ fontSize: '20px', color: '#6c757d' }}>
            {text}
          </blockquote>

          <footer className="text-end">
            <cite className="fw-bold d-block" style={{ fontSize: '18px', color: '#495057' }}>
              ⎯ {author}
            </cite>
            <small className="text-muted" style={{ fontSize: '12px' }}>
              {location}
            </small>
          </footer>
        </div>
      </div>
    </div>
  );
};
